export default __webpack_public_path__ + "static/media/about-loggi-ponto.7fa187b5.png";